<div class="page-chat content-layout" fxLayout="column">

    <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column">

        <calsoft-breadcrumbs [url]="dealId==0?'deals,Add Deals':'deals,Edit Deals'"
            [currentPage]="dealId==0?'Deals,Add Deals':'Deals,Edit Deals'" [header]="'primary'">
        </calsoft-breadcrumbs>


        <div *ngIf="!dealAdd && dealId == 0" fxLayout="column" fxLayoutGap="24px" fxFlex>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space flex-1" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-editdeals-btn-1' + '__' + sanitizedUrl" (click)="back()"
                                matTooltip="Back" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button> {{title}}
                        </div>
                    </div>
                    <div class="content" fxLayout="column">
                        <div class="result" fxLayout="column">
                            <div class="container">
                                <div id="content">
                                    <div class="products-padding">
                                        <div class="editSets" [formGroup]="firstFormGroup">
                                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                                <span>Create Deals Settings
                                                </span>
                                            </div>
                                            <div class="products-padding">
                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">

                                                    <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Attribute Set</mat-label>
                                                        <mat-select formControlName="attributeSet"
                                                            [disableOptionCentering]="true" required #singleSelect>
                                                            <mat-option>
                                                                <ngx-mat-select-search name="Attribute Search"
                                                                    ngDefaultControl
                                                                    [formControl]="attributeFilterControl"
                                                                    placeholderLabel="Attribute Search"
                                                                    [preventHomeEndKeyPropagation]="true"
                                                                    noEntriesFoundLabel="No data found">
                                                                </ngx-mat-select-search>
                                                            </mat-option>
                                                            <mat-option
                                                                *ngFor="let item of filteredAttributeList; let i=index;"
                                                                [value]="item.attributeSetId">
                                                                {{item.attributeSetName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngFor="let validation of createAttributeValidations.attributeSet">
                                                            <mat-error class="error-message"
                                                                *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                                {{validation.message}}
                                                            </mat-error>
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="btn" fxLayoutAlign="end center">
                                                <button [attr.guide]="'add-editdeals-btn-2' + '__' + sanitizedUrl"
                                                    [disabled]="textAdd !='Create'" (click)="getAttributeGroup()"
                                                    mat-raised-button>
                                                    {{textAdd}}
                                                    <mat-icon *ngIf="textAdd !='Create' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card flex-1" fxFlex fxLayout="column" *ngIf="dealAdd">
            <mat-drawer-container fxFlex>

                <mat-drawer [mode]="mobileQuery.matches ? 'over' : 'side'" (openedChange)="drawerChange($event)"
                    [opened]="drawerOpen$ | async" class="mat-elevation-z1 drawer" position="start">

                    <div class="sidenav-container" fxFlex fxLayout="column">
                        <div class="chat-toolbar " fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-editdeals-btn-3' + '__' + sanitizedUrl" fxHide fxShow.gt-md
                                fxShow.gt-sm matTooltip="Back" (click)="back()" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            <span fxHide fxShow.gt-md fxShow.gt-sm>{{title}}</span>
                            <span fxHide fxShow.lt-md fxShow.lt-sm>Select a Tab</span>
                            <span fxFlex>
                            </span>

                        </div>
                        <div class="flex-auto  overflow-hidden">
                            <calsoft-scrollbar class="flex-auto">
                                <mat-nav-list class="chat-contacts">
                                    <mat-list-item class="chat-contact" (click)="get(item.attributeGroupName,i,item)"
                                        *ngFor="let item of regConfig; let i = index"
                                        [attr.guide]="'add-editdeals-tab' + i + '__' + sanitizedUrl"
                                        [class.highlighted]="item.attributeGroupName == groupName "
                                        isMatnavlistOpen=false; class="nav-list">

                                        <div fxLayoutAlign="start center" fxLayoutGap="20px">
                                            <a matLinevalue="menu">
                                                {{ item.attributeGroupName }}
                                            </a>

                                            <div *ngIf="invalidMap.get(i) ==undefined">
                                                <mat-icon class="success">
                                                    check_circle_outline</mat-icon>
                                            </div>

                                            <div *ngIf="invalidMap.get(i) !=undefined">

                                                <div *ngIf="checkValidataion(i); else elseBlock">

                                                    <mat-icon class="danger">
                                                        error_outline</mat-icon>
                                                </div>
                                                <ng-template #elseBlock>
                                                    <mat-icon class="success">
                                                        check_circle_outline</mat-icon>
                                                </ng-template>
                                            </div>

                                        </div>
                                    </mat-list-item>
                                </mat-nav-list>
                            </calsoft-scrollbar>
                        </div>
                    </div>
                </mat-drawer>
                <mat-drawer-content>
                    <div class="chat-inner-container" fxFlex fxLayout="column">
                        <div class="chat-toolbar" fxLayout="row" fxLayoutAlign="start center">

                            <button [attr.guide]="'add-editdeals-btn-4' + '__' + sanitizedUrl" fxHide fxShow.lt-md
                                type="button" mat-icon-button (click)="openDrawer()">
                                <mat-icon>menu</mat-icon>
                            </button>

                            <div class="current-contact" fxLayout="row" fxLayoutAlign="start center">


                                <div fxLayout="column" fxLayoutAlign="center">

                                    <span class="status"></span>
                                </div>
                            </div>

                            <span fxFlex>
                            </span>
                            <div fxLayout="row" fxLayoutGap="10px">
                                <button [attr.guide]="'add-editdeals-btn-5' + '__' + sanitizedUrl" mat-icon-button
                                    *ngIf="dealId != 0" (click)="audit('table')">
                                    <mat-icon>calendar_today</mat-icon>
                                </button>
                                <button [attr.guide]="'add-editdeals-btn-6' + '__' + sanitizedUrl"
                                    [disabled]="text !='Save'" (click)="save()" mat-raised-button>
                                    {{text}}
                                    <mat-icon *ngIf="text !='Save' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>

                        </div>
                        <div class="flex-auto flex flex-col min-h-0 overflow-hidden" fxFlex>
                            <calsoft-scrollbar #tabsContentRef class="p-4  flex-auto">
                                <ng-container *ngIf="regConfig?.length > 0">
                                    <div>
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>{{groupName}}</span>
                                            </div>
                                            <div class="result" fxLayout="column">
                                                <ng-container *ngFor="let field of regConfig[defalutValue]
                                                    ['eavEntityAttribute'];" dynamicField
                                                    [field]="field['eavAttribute']" [data]="data" [group]="form">
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>


                                </ng-container>
                            </calsoft-scrollbar>
                        </div>
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
    </div>
</div>